import { NoAttribution, OrgRole } from "@hex/common";
import React from "react";
import { Navigate } from "react-router-dom";
import { styled } from "styled-components";

import { WarningIcon } from "../../components/icons/CustomIcons";
import {
  HexCard,
  HexNonIdealState,
  HexSpinner,
  HexSpinnerSizes,
} from "../../hex-components";
import { useMeQuery } from "../../route/HexRoutes.generated";
import { Routes } from "../../route/routes";

import { CliAuthFlow } from "./CliAuthFlow";
import { getCurrentUrl } from "./util";

export const CliAuthView = React.memo(function CliAuthView() {
  return (
    <Layout>
      <EnsureLoggedIn>
        <AuthCard>
          <CliAuthFlow />
        </AuthCard>
      </EnsureLoggedIn>
    </Layout>
  );
});

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  height: 100vh;
  width: 100vw;
  background-color: ${({ theme }) => theme.backgroundColor.OVERLAY};
`;

const AuthCard = styled(HexCard)`
  display: flex;
  flex-direction: column;
  gap: 12px;

  position: relative;
  top: +20vh;
  width: 500px;
  padding: 40px;

  @media (max-width: 600px) {
    width: 100%;
    top: 0;
    padding: 20px;
    height: 100%;
    overflow: auto;
  }
`;

const EnsureLoggedIn = React.memo(function EnsureLoggedIn({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data: meData, error, loading } = useMeQuery();

  const loggedOut =
    !loading &&
    (!meData?.me || error || meData.me.orgRole === OrgRole.ANONYMOUS);
  if (loggedOut) {
    // deflect to login
    const redirectBackHere = getCurrentUrl();
    return (
      <Navigate
        replace={true}
        to={Routes.LOGIN.getUrl({
          attribution: NoAttribution,
          queryParams: { redirectTo: redirectBackHere },
        })}
      />
    );
  }

  if (!meData && loading) {
    return <HexSpinner size={HexSpinnerSizes.LARGE} />;
  } else if (!meData || error || !meData.me || !meData.myOrg) {
    return (
      <HexNonIdealState
        description="There was an unexpected error. Please contact support@hex.tech for assistance."
        icon={<WarningIcon />}
        title="Something went wrong"
      />
    );
  } else {
    // logged in
    return children;
  }
});
